import React from "react";
import "./AboutUs.css";
import SEO from "../../../components/SEO/SEO";
import AboutUsLanding from "../../../components/SubComponents/AboutUsLanding";
import ContactSection from "../../../components/ContactSection/ContactSection";
import { getOrganizationStructuredData, getBreadcrumbStructuredData, getAboutPageStructuredData } from "../../../components/SEO/StructuredData";

const CORE_VALUES = [
  { title: "Integrity", desc: "Zero compromise on ethics." },
  { title: "Compliance", desc: "100% statutory adherence." },
  { title: "People First", desc: "Empowering teams and clients." },
  { title: "Commitment", desc: "Delivering more than expectations." },
  { title: "Innovation", desc: "Digitised processes & modern HR solutions." },
];

const DELIVER_ITEMS = [
  "4,500+ Deployed Workforce",
  "PAN India Delivery Network",
  "10+ Years of Industry Experience",
  "100% Statutory Compliance",
  "Trusted by BFSI, NBFC, FMCG, Manufacturing & Retail Leaders",
  "Dedicated Client Servicing Model",
];

export default function AboutUs() {
  const structuredData = [
    getOrganizationStructuredData(),
    getAboutPageStructuredData(),
    getBreadcrumbStructuredData([
      { name: "Home", url: "https://adamanthr.com" },
      { name: "About Us", url: "https://adamanthr.com/aboutus" },
    ]),
  ];

  return (
    <div>
      <SEO
        title="About Us - Adamant HR Consulting | Leading HR Agency in Noida, NCR India"
        description="Learn about Adamant HR Consulting Pvt. Ltd. - A premier workforce and compliance solutions organisation with 10+ years of experience, 4500+ candidates placed, serving BFSI, NBFC, FMCG, Manufacturing, and Retail sectors across India."
        keywords="about Adamant HR, HR company Noida, workforce solutions company, HR consulting firm India, staffing company NCR, recruitment agency Noida"
        url="https://adamanthr.com/aboutus"
        structuredData={structuredData}
      />

      <AboutUsLanding />

      <div className="about-industries-section">
        <div className="about-industries-inner">
          <div className="about-mission-vision-grid">
            <div className="about-mission-card">
              <h2>Our Mission</h2>
              <p>
                &ldquo;To deliver world-class workforce, security, compliance, and
                operational solutions that empower businesses to scale with
                confidence, transparency, and trust.&rdquo;
              </p>
            </div>
            <div className="about-mission-card">
              <h2>Our Vision</h2>
              <p>
                &ldquo;To be India&rsquo;s most reliable and respected workforce solutions
                partner, enabling organisations to grow through integrity, innovation,
                and people excellence.&rdquo;
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="about-values-section">
        <div className="about-values-inner">
          <h1 className="about-section-heading">Our Core Values</h1>
          <div className="about-values-grid">
            {CORE_VALUES.map((v, i) => (
              <div key={i} className="about-value-card">
                <span className="about-value-icon">✓</span>
                <div>
                  <strong>{v.title}</strong>
                  <p>{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="about-leadership-section">
        <div className="about-leadership-inner">
          <h1 className="about-section-heading">Our Leadership Strength</h1>
          <p>
            Adamant HR is led by experienced professionals with deep expertise in
            recruitment, compliance, statutory operations, and enterprise
            workforce management.
          </p>
          <p className="about-leadership-quote">
            &ldquo;Deliver excellence. Build trust. Ensure results.&rdquo;
          </p>
        </div>
      </div>

      <div className="about-deliver-section">
        <h1 className="about-section-heading">What We Deliver</h1>
        <div className="about-deliver-inner">
          <div className="about-deliver-grid">
            {DELIVER_ITEMS.map((item, i) => (
              <div key={i} className="about-deliver-item">
                <span className="about-deliver-check">✔</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ContactSection />
    </div>
  );
}
